<template>
  <div
    v-if="!disabled"
    class="ds-control ds-virtual-scroll ds-no-padding"
    :class="getCss"
    :style="rootStyle"
  >
    <div
      ref="box"
      class="ds-virtual-scroll-box __virtual"
      :style="boxStyle"
      slot-name="default"
      v-on="boxEvent"
      v-onresize="$updateBar"
      v-onresize-disabled="disabled">
      <div
        class="ds-virtual-scroll-box_warp"
        ref="view"
        v-onresize="$updateBar"
        v-onresize-disabled="disabled">
        <slot name="default"></slot>
      </div>
    </div>
    <div ref="xBar" class="ds-virtual-scroll-bar __x" :class="{ down: xType }" :style="{ width: xBarLength + 'px' }" @mousedown.self="xDown" />
    <div ref="yBar" class="ds-virtual-scroll-bar __y" :class="{ down: yType }" :style="{ height: yBarLength + 'px' }" @mousedown.self="yDown" />
  </div>
  <div v-else class="ds-control ds-virtual-scroll" :style="rootStyle">
    <div ref="box" class="ds-virtual-scroll-box" slot-name="default">
      <slot name="default"></slot>
    </div>
  </div>
</template>

<script>
let isCompatible = true;
let { browser, version } = dsf.client.info;
if (
  (browser == "IE" && equalVersion("10.0")) ||
  (browser.indexOf("Firefox") == 0 && equalVersion("64.0")) ||
  ((browser == "Chrome" || browser == "Chromium") && equalVersion("4.0")) ||
  (browser == "Edge" && equalVersion("79.0")) ||
  (browser == "Safari" && equalVersion("5.1")) ||
  (browser == "Opera" && equalVersion("15.0"))
) {
  isCompatible = false;
}
function equalVersion(v) {
  v = v.split(".");
  let v2 = version.split(".");
  for (let i = 0, l = Math.min(v2.length, v.length); i < l; i++) {
    if (+v[i] < +v2[i]) {
      return false;
    }
  }
  return true;
}

export default dsf.component({
  name: "DsfVirtualScroll",
  ctrlCaption: "虚拟滚动盒",
  mixins: [$mixins.layout],
  design: {
    isMask: false,
  },
  props: {
    scrollX: {
      type: Boolean,
      default: false,
    },
    scrollY: {
      type: Boolean,
      default: true,
    },
    height: {
      type: String,
      default: "100%",
    },
    width: {
      type: String,
      default: "auto",
    },
    maxHeight: {
      type: String,
      default: "none",
    },
    slots: {
      type: Array,
      default() {
        return [{ name: "default", controls: [] }];
      },
    },
  },
  data() {
    this.x = 0;
    this.y = 0;
    return {
      disabled: dsf.config.setting_public_virtual_scroll || false,
      xType: false,
      yType: false,
      xBarLength: 0,
      yBarLength: 0,
      showXBar: true,
      showYBar: true,
    };
  },
  computed: {
    getCss(){
      return [
        ...this.$getClass(),
        this.scrollX && this.showXBar?'__scroll-x':'',
        this.scrollY && this.showYBar?'__scroll-y':''
      ]
    },
    rootStyle() {
      let res = {};
      let width = this.width;
      let height = this.height;
      let maxHeight = this.maxHeight;
      if (width && width !== "auto" && width !== "100%") {
        res["width"] = width;
      }
      if (height && height !== "auto" && height !== "none") {
        res["height"] = height;
      }
      if (maxHeight && maxHeight !== "auto" && maxHeight !== "none") {
        res["max-height"] = maxHeight;
      }
      if (this.isDesign) {
        this.$dispatch("design-height-change", height);
        res.height = "100%";
      }
      return res;
    },
    boxStyle() {
      let res = {};
      let maxHeight = this.maxHeight;
      if (maxHeight && maxHeight !== "auto" && maxHeight !== "none") {
        res["max-height"] = maxHeight;
      }
      if (!isCompatible) {
        res["overflow-x"] = "auto";
        res["overflow-y"] = "auto";
        if (this.scrollX) {
          res["overflow-y"] = "hidden";
        }
        if (this.scrollY) {
          res["overflow-x"] = "hidden";
        }
      } else {
        res["overflow-x"] = "visible";
        res["overflow-y"] = "visible";
        if (this.scrollX) {
          res["overflow-x"] = "auto";
        }
        if (this.scrollY) {
          res["overflow-y"] = "auto";
        }
      }
      return res;
    },
    boxEvent() {
      let res = {
        scroll: this.onScroll,
        mouseenter: this.updateBar,
      };
      if (!isCompatible && (this.scrollX || this.scrollY) && !this.xType && !this.yType) {
        res["wheel"] = this.onWheel;
      }
      return res;
    },
  },
  watch: {
    showXBar: {
      handler(to) {
        this.$emit("show-x-bar", to);
      },
      immediate: true,
    },
    showYBar: {
      handler(to) {
        this.$emit("show-y-bar", to);
      },
      immediate: true,
    },
  },
  created() {
    if (!this.disabled) {
      this.$updateBar = _.throttle(this.updateBar, isCompatible ? 16 : 500, {
        leading: false,
        trailing: true,
      });
    }
  },
  mounted() {
    if (this.disabled) return;
    this.$box = this.$refs.box;
    this.$view = this.$refs.view;
    this.$nextTick(this.updateBar);
  },
  methods: {
    reloadData() {
      this.$childrenReloadData();
    },
    resize() {
      this.$updateBar();
    },
    setBarPosition(y) {
      let bar = this.$refs[y + "Bar"];
      if (bar) {
        bar.style.transform = `translate${y.toLocaleUpperCase()}(${this[y]}px)`;
      }
    },
    updateBar() {
      if (!this.$box) return;
      if (this.scrollX && this.$refs.xBar) {
        this._updateBar("x", "X", "Width", "Left");
      }
      if (this.scrollY && this.$refs.yBar) {
        this._updateBar("y", "Y", "Height", "Top");
      }
    },
    _updateBar(y, Y, Height, Top) {
      let offsetHeight = this.$box["offset" + Height];
      let scrollHeight = this.$box["scroll" + Height];
      let scrollTop = this[y + "Type"] ? this["scroll" + Top] : this.$box["scroll" + Top];
      let yBarLength = this.$refs[y + "Bar"]["offset" + Height];
      let yScale = offsetHeight / scrollHeight;
      if (yScale >= 1) {
        this["show" + Y + "Bar"] = false;
        this[y] = 0;
      } else {
        this["show" + Y + "Bar"] = true;
        yBarLength = Math.floor(yScale * (offsetHeight - 10));
        this[y + "BarLength"] = yBarLength = yBarLength < 30 ? 30 : yBarLength;
        this[y] = Math.floor(((offsetHeight - yBarLength - 10) * scrollTop) / (scrollHeight - offsetHeight));
      }
      this.setBarPosition(y);
    },
    onScroll(e) {
      if (this.scrollX && !this.xType && this.$refs.xBar) {
        this._onScroll("x", "Width", "Left");
      }
      if (this.scrollY && !this.yType && this.$refs.yBar) {
        this._onScroll("y", "Height", "Top");
      }
      this.$emit("scroll", e, this.$box);
    },
    _onScroll(y, Height, Top) {
      let offsetHeight = this.$box["offset" + Height];
      let scrollHeight = this.$box["scroll" + Height];
      let scrollTop = this.$box["scroll" + Top];
      let yBarLength = this.$refs[y + "Bar"]["offset" + Height];
      this[y] = Math.floor(((offsetHeight - yBarLength - 10) * scrollTop) / (scrollHeight - offsetHeight));
      this.setBarPosition(y);
    },
    // 拖动滚动条
    xDown(event) {
      const e = event || window.event;
      this.xType = true;
      this.lastX = e.screenX;
      this.scrollLeft = this.$box.scrollLeft;
      window.addEventListener("mousemove", this.move, true);
      window.addEventListener("mouseup", this.up, true);
    },
    yDown(event) {
      const e = event || window.event;
      this.yType = true;
      this.lastY = e.screenY;
      this.scrollTop = this.$box.scrollTop;
      window.addEventListener("mousemove", this.move, true);
      window.addEventListener("mouseup", this.up, true);
    },
    move(event) {
      const e = event || window.event;
      if (this.xType && this.$refs.xBar) {
        this._move(e, "x", "X", "Width", "Left");
      }
      if (this.yType && this.$refs.yBar) {
        this._move(e, "y", "Y", "Height", "Top");
      }
    },
    _move(e, y, Y, Height, Top) {
      let offsetHeight = this.$box["offset" + Height];
      let scrollHeight = this.$box["scroll" + Height];
      let yBarLength = this.$refs[y + "Bar"]["offset" + Height];
      let maxY = offsetHeight - yBarLength - 10;
      let thisY = e["screen" + Y];
      let _y = this[y] + thisY - this["last" + Y];
      this["last" + Y] = thisY;
      if (_y < 0) {
        _y = 0;
      } else if (_y > maxY) {
        _y = maxY;
      }
      this[y] = _y;
      this["scroll" + Top] = this.$box["scroll" + Top] = (_y / maxY) * (scrollHeight - offsetHeight);
      this.setBarPosition(y);
    },
    up() {
      this.xType = false;
      this.yType = false;
      window.removeEventListener("mousemove", this.move, true);
      window.removeEventListener("mouseup", this.up, true);
    },
    // ie 下触摸板无解
    onWheel(e) {
      let {pixelX, pixelY} = dsf.normalizeWheel(e);
      if (!pixelY && !pixelX) return;
      if (e.shiftKey && pixelY) {
        pixelX = pixelY;
      }
      this._mouseWheel(pixelX, pixelY, e);
    },
    _mouseWheel(deltaX, deltaY, e) {
      if (deltaX) {
        this.__mouseWheel(deltaX, e, "X", "Width", "Left");
      }
      if (deltaY) {
        this.__mouseWheel(deltaY, e, "Y", "Height", "Top");
      }
    },
    __mouseWheel(zoom, e, Y, Height, Top) {
      let _sh = this.$box["scroll" + Height] - this.$box["offset" + Height];
      if ((zoom < 0 && this.$box["scroll" + Top] == 0) || (zoom > 0 && _sh == this.$box["scroll" + Top])) {
        return;
      }
      if (this["scroll" + Y] && this["show" + Y + "Bar"]) {
        e.stopPropagation();
        e.preventDefault();
      }
      this.$box["scroll" + Top] += zoom;
    },
    scrollTo(...options) {
      this.$box.scrollTo(...options);
    },
    scrollBy(...options) {
      this.$box.scrollBy(...options);
    },
    getScrollInfo() {
      let {scrollTop, scrollLeft, scrollHeight, scrollWidth} = this.$box;
      return {scrollTop, scrollLeft, scrollHeight, scrollWidth};
    }
  },
});
</script>
